var render = function render(){var _vm=this,_c=_vm._self._c;return _c('group-form',{attrs:{"group":_vm.group,"formAction":"/venue-group"},on:{"submitSuccess":_vm.onSubmitSuccess},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('ez-button',{attrs:{"form-type":"submit"}},[_vm._v("Save Changes")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }